<template>
  <ParamList :module="module" />
</template>
<script>
import pageParamMixin from "@/mixins/page/pageParamMixin";
import ParamList from "@/views/modules/general/Param";
export default {
  name: 'SettingParam',
  mixins: [pageParamMixin],
  components: {ParamList}, //Declarado aqui fora, pois a página de Mixin é usada dentro dos componentes ParamList e ParaForm
  data() {
    return {
      module: "checklist",
    }
  },
}
</script>
